import { useQuery, UseQueryOptions } from 'react-query'
import { ApiClient } from 'services/ApiClient'
import { Api } from 'types/Api'
import { Discount } from '../../models/Discount'

export namespace FetchDefaultDiscount {
  export type Response = Discount
  export type Error = Api.Error
  export type Options = UseQueryOptions<Response, Error>
}

const createKey = () => ['default-discount']

const queryFetcher = () => () => {
  return ApiClient.get<FetchDefaultDiscount.Response>('/v1/discounts/default/show')
}

export const useFetchDefaultDiscount = (options?: FetchDefaultDiscount.Options) => {
  return useQuery<FetchDefaultDiscount.Response, FetchDefaultDiscount.Error>(
    createKey(),
    queryFetcher(),
    options
  )
}